import { TypeIdSchema, organization, organizationMember, subscription } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';
import { PublicUserSchema } from '../user/user.schema';

export const OrganizationSchema = createSelectSchema(organization);
export type Organization = typeof organization.$inferSelect;

export const SubscriptionSchema = createSelectSchema(subscription);
export type Subscription = typeof subscription.$inferSelect;

export const InsertSubscriptionSchema = createInsertSchema(subscription);
export type InsertSubscription = typeof subscription.$inferInsert;

export const InsertOrganizationSchema = createInsertSchema(organization);
export type InsertOrganization = typeof organization.$inferInsert;

const PublicSubscriptionSchema = Type.Omit(SubscriptionSchema, [
  'stripe_id',
  'id',
  'is_current',
  'usage_subscription_item_stripe_id',
  'usage_next_snapshot_at',
]);

export const PublicOrganizationSchema = Type.Composite([
  Type.Omit(OrganizationSchema, [
    'id',
    'public_id',
    'stripe_customer_id',
    'brevo_company_id',
    'subscription_id',
    'proxy_rules',
    'usage_initialized_at',
  ]),
  Type.Object({
    object: Type.Literal('Organization'),
    id: TypeIdSchema('organization'),
    current_subscription: Type.Union([Type.Null(), PublicSubscriptionSchema]),
  }),
]);

export type PublicOrganization = Static<typeof PublicOrganizationSchema>;

export const OrganizationMemberSchema = createSelectSchema(organizationMember);
export type OrganizationMember = typeof organizationMember.$inferSelect;

export const InsertOrganizationMemberSchema = createInsertSchema(organizationMember);
export type InsertOrganizationMember = typeof organizationMember.$inferInsert;

export const PublicOrganizationMemberSchema = Type.Composite([
  Type.Omit(OrganizationMemberSchema, ['organization_id', 'user_id']),
  Type.Object({
    object: Type.Literal('OrganizationMember'),
    user: Type.Optional(PublicUserSchema),
  }),
]);

export type PublicOrganizationMember = Static<typeof PublicOrganizationMemberSchema>;
